/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { AppUserCm } from '../models/app-user-cm';
import { PoolRoleCm } from '../models/pool-role-cm';

@Injectable({
  providedIn: 'root',
})
export class AccountApi extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getAppUser
   */
  static readonly GetAppUserPath = '/api/Account/GetAppUser';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAppUser$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAppUser$Plain$Response(params?: {
    context?: HttpContext
  }
): Observable<StrictHttpResponse<AppUserCm>> {

    const rb = new RequestBuilder(this.rootUrl, AccountApi.GetAppUserPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AppUserCm>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getAppUser$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAppUser$Plain(params?: {
    context?: HttpContext
  }
): Observable<AppUserCm> {

    return this.getAppUser$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<AppUserCm>) => r.body as AppUserCm)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAppUser()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAppUser$Response(params?: {
    context?: HttpContext
  }
): Observable<StrictHttpResponse<AppUserCm>> {

    const rb = new RequestBuilder(this.rootUrl, AccountApi.GetAppUserPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AppUserCm>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getAppUser$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAppUser(params?: {
    context?: HttpContext
  }
): Observable<AppUserCm> {

    return this.getAppUser$Response(params).pipe(
      map((r: StrictHttpResponse<AppUserCm>) => r.body as AppUserCm)
    );
  }

  /**
   * Path part for operation getPoolRoles
   */
  static readonly GetPoolRolesPath = '/api/Account/GetPoolRoles';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPoolRoles$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPoolRoles$Plain$Response(params?: {
    context?: HttpContext
  }
): Observable<StrictHttpResponse<Array<PoolRoleCm>>> {

    const rb = new RequestBuilder(this.rootUrl, AccountApi.GetPoolRolesPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<PoolRoleCm>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getPoolRoles$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPoolRoles$Plain(params?: {
    context?: HttpContext
  }
): Observable<Array<PoolRoleCm>> {

    return this.getPoolRoles$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<Array<PoolRoleCm>>) => r.body as Array<PoolRoleCm>)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPoolRoles()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPoolRoles$Response(params?: {
    context?: HttpContext
  }
): Observable<StrictHttpResponse<Array<PoolRoleCm>>> {

    const rb = new RequestBuilder(this.rootUrl, AccountApi.GetPoolRolesPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<PoolRoleCm>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getPoolRoles$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPoolRoles(params?: {
    context?: HttpContext
  }
): Observable<Array<PoolRoleCm>> {

    return this.getPoolRoles$Response(params).pipe(
      map((r: StrictHttpResponse<Array<PoolRoleCm>>) => r.body as Array<PoolRoleCm>)
    );
  }

  /**
   * Path part for operation getRoles
   */
  static readonly GetRolesPath = '/api/Account/GetRoles';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getRoles$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRoles$Plain$Response(params?: {
    context?: HttpContext
  }
): Observable<StrictHttpResponse<Array<string>>> {

    const rb = new RequestBuilder(this.rootUrl, AccountApi.GetRolesPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<string>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getRoles$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRoles$Plain(params?: {
    context?: HttpContext
  }
): Observable<Array<string>> {

    return this.getRoles$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<Array<string>>) => r.body as Array<string>)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getRoles()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRoles$Response(params?: {
    context?: HttpContext
  }
): Observable<StrictHttpResponse<Array<string>>> {

    const rb = new RequestBuilder(this.rootUrl, AccountApi.GetRolesPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<string>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getRoles$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRoles(params?: {
    context?: HttpContext
  }
): Observable<Array<string>> {

    return this.getRoles$Response(params).pipe(
      map((r: StrictHttpResponse<Array<string>>) => r.body as Array<string>)
    );
  }

}
